import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const BREAST_FORM_INITIAL_VALUES = {
  sections: {
    breast: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamBreastSections = keyof typeof BREAST_FORM_INITIAL_VALUES.sections;
